/**
 * Фото-лента карточки (фидбек 27.07): горизонтальная лента превью из
 * карточки арендатора (живой слой occupants), тап — полноэкранный лайтбокс
 * со свайпом/стрелками. Превью *_t.jpg грузятся мгновенно.
 */

import { tr } from '@app/i18n'
import { useState } from 'preact/hooks'

/** Превью-вариант: серверная нарезка кладёт рядом <name>_t.jpg. */
function thumbOf(url: string): string {
  return url.replace(/\.jpg$/i, '_t.jpg')
}

export function PhotoStrip({ photos }: { photos: readonly string[] }) {
  const [openIdx, setOpenIdx] = useState<number | null>(null)
  if (photos.length === 0) return null
  return (
    <>
      <div class="photo-strip">
        {photos.map((url, i) => (
          <button
            key={url}
            type="button"
            class="photo-thumb"
            aria-label={tr('card.photo_n', { n: String(i + 1) })}
            onClick={() => setOpenIdx(i)}
          >
            <img
              src={thumbOf(url)}
              alt=""
              loading="lazy"
              onError={(e) => {
                // Фото без серверного превью (загружено до нарезки) — оригинал.
                const el = e.currentTarget as HTMLImageElement
                if (!el.dataset['fb']) {
                  el.dataset['fb'] = '1'
                  el.src = url
                }
              }}
            />
          </button>
        ))}
      </div>
      {openIdx !== null && (
        <div
          class="photo-lightbox"
          role="dialog"
          aria-label={tr('card.photo_n', { n: String(openIdx + 1) })}
        >
          <button
            type="button"
            class="photo-lb-close icon-btn"
            aria-label={tr('common.close')}
            onClick={() => setOpenIdx(null)}
          >
            ✕
          </button>
          <img src={photos[openIdx]} alt="" class="photo-lb-img" />
          {photos.length > 1 && (
            <div class="photo-lb-nav">
              <button
                type="button"
                class="icon-btn"
                aria-label="‹"
                onClick={() => setOpenIdx((openIdx + photos.length - 1) % photos.length)}
              >
                ‹
              </button>
              <span class="photo-lb-count">
                {openIdx + 1} / {photos.length}
              </span>
              <button
                type="button"
                class="icon-btn"
                aria-label="›"
                onClick={() => setOpenIdx((openIdx + 1) % photos.length)}
              >
                ›
              </button>
            </div>
          )}
        </div>
      )}
    </>
  )
}
